import Modal from "@mui/material/Modal";
import { Chip, styled } from "@mui/material";
import { isMobile } from "react-device-detect";
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { openLoginModal } from "../../../redux/actions/mainAction";
import { useTranslation } from "react-i18next";
import CustomTextFields from "../../Fields/CustomTextFields";
import CustomButton from "../../Buttons/CustomButton";
import { CreateInstallmentTemporary } from "../../../api/services/products.api";
import { useSnackbar } from "notistack";

const Root = styled("div")(({ theme }) => ({
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#ffffff",
  position: "absolute",
  borderRadius: "16px",
  outline: "none !important",
  padding: "20px",
  width: isMobile ? 320 : 600,
  border: "1px solid #1E90FF",

  "& .title": {
    textAlign: "center",
    fontSize: isMobile ? "14px" : "18px",
    fontWeight: "bold",
    marginBottom: "10px",
  },

  "& .details-info": {
    marginTop: "20px",
    marginBottom: isMobile ? "10px" : "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  "& .danger": {
    fontSize: isMobile ? "9px" : "12px",
    fontWeight: "bold",
    marginTop: isMobile ? "4px" : "10px",
    color: "#e39124",
  },
}));

const ChipWrapper = styled("div")({
  display: "flex",
  gap: "8px",
  marginTop: "16px",

  "& .MuiChip-label": {
    fontSize: isMobile ? "11px" : "",
  },
});

const MobileReadyToBuy = ({
  readyToBy,
  setReadyToBy,
  isUserAuthorized,
  productId,
  data,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [isLinkReady, setIsLinkReady] = useState(null);
  const [orderInfo, setOrderInfo] = useState({
    deliveryType: "pickup",
    address: "თბილისი, საბურთალო #24 პეკინის გამზირი",
  });
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (readyToBy && readyToBy.open && !isUserAuthorized) {
      dispatch(openLoginModal(true));
      setReadyToBy({
        type: "",
        open: false,
      });
    }
  }, [readyToBy, isUserAuthorized]);

  const handleChipClick = (option) => {
    setOrderInfo({
      ...orderInfo,
      deliveryType: option,
      address:
        option === "pickup" ? "თბილისი, საბურთალო #24 პეკინის გამზირი" : "",
    });
  };

  const onChange = (key, value) => {
    setOrderInfo({ ...orderInfo, [key]: value });
  };

  const getInstallmentType = () => {
    switch (readyToBy.type) {
      case "BOGBUY":
        return 0;
      case "BOGINSTALLMENT":
        return 1;
      case "TBCINSTALLMENT":
        return 2;
      case "CREDOINSTALLMENT":
        return 3;
      default:
        return -1;
    }
  };

  const openModal = () => {
    if (!window.BOG) {
      return;
    }

    window.BOG.Calculator.open({
      amount: data.price,
      onRequest: (selected, successCb, closeCb) => {
        onSubmitOrder(selected, successCb, closeCb);
      },
      onComplete: ({ redirectUrl }) => {
        window.location.href = redirectUrl;
      },
      onClose: () => {},
    });
  };

  const onSubmitOrder = (selected, successCb, closeCb) => {
    const InstallmentType = getInstallmentType();
    if (InstallmentType < 0) {
      return;
    }

    let payload = {
      DeliveryType: orderInfo.deliveryType === "pickup" ? 0 : 1,
      InstallmentType,
      Address: orderInfo.address,
      Name: orderInfo.name,
      Surname: orderInfo.surname,
      Email: orderInfo.email,
      MobileNumber: orderInfo.mobileNumber,
      Note: orderInfo.note ?? "",
      ProductId: productId,
    };

    if (selected) {
      payload = { ...payload, ...selected };
    }

    if (
      !payload.Name ||
      !payload.Address ||
      !payload.Surname ||
      !payload.Email ||
      !payload.MobileNumber
    ) {
      enqueueSnackbar(t("pleaseFillAllRequiredFields"), {
        variant: "warning",
      });
      return;
    }

    setLoading(true);

    CreateInstallmentTemporary(payload)
      .then((res) => {
        const redirectUrl = res.data;

        if (successCb && redirectUrl) {
          setDisabled(true);
          const orderId = redirectUrl;
          successCb(orderId);

          setTimeout(() => {
            setReadyToBy({
              type: "",
              open: false,
            });
            setDisabled(false);
          }, 3000);

          return;
        }

        if (redirectUrl) {
          enqueueSnackbar(t("yourRequestIsAccepted"), {
            variant: "success",
          });

          setDisabled(true);

          // Delay URL assignment to simulate "loading"
          setTimeout(() => {
            setIsLinkReady(redirectUrl);
            setDisabled(false);
          }, 4000);
        }
      })
      .catch(() => {
        enqueueSnackbar(t("errorPleaseContactWebsiteAdministrator"), {
          variant: "error",
        });
        setLoading(false);
        if (closeCb) {
          closeCb();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      open={readyToBy.open && isUserAuthorized}
      onClose={() =>
        setReadyToBy({
          type: "",
          open: false,
        })
      }
      sx={{
        "& .MuiBackdrop-root": {
          border: "none",
        },
        "& .MuiPaper-root": {
          border: "none",
        },
      }}
    >
      <Root>
        <p className="title">{t("orderDetails")}</p>
        <span className="danger">{t("beCarefullyFillCorrectInfo")}</span>
        <ChipWrapper>
          <Chip
            size={isMobile ? "small" : "medium"}
            label={t("takeMySelf")}
            color={orderInfo.deliveryType === "pickup" ? "primary" : "default"}
            onClick={() => handleChipClick("pickup")}
            variant={
              orderInfo.deliveryType === "pickup" ? "filled" : "outlined"
            }
            clickable
          />
          <Chip
            size={isMobile ? "small" : "medium"}
            label={t("bringItToMe")}
            color={
              orderInfo.deliveryType === "delivery" ? "primary" : "default"
            }
            onClick={() => handleChipClick("delivery")}
            variant={
              orderInfo.deliveryType === "delivery" ? "filled" : "outlined"
            }
            clickable
          />
        </ChipWrapper>
        <div className="details-info">
          <CustomTextFields
            placeholder={t("receiverAddress")}
            onChange={(val) => onChange("address", val)}
            disabled={orderInfo.deliveryType === "pickup"}
            value={orderInfo.address}
            size={isMobile ? "small" : "medium"}
          />

          <div
            style={{
              display: "flex",
              gap: "10px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <CustomTextFields
              placeholder={t("receiverName")}
              onChange={(val) => onChange("name", val)}
              size={isMobile ? "small" : "medium"}
            />
            <CustomTextFields
              placeholder={t("receiverSurname")}
              onChange={(val) => onChange("surname", val)}
              size={isMobile ? "small" : "medium"}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <CustomTextFields
              placeholder={t("receiverEmail")}
              onChange={(val) => onChange("email", val)}
              size={isMobile ? "small" : "medium"}
            />
            <CustomTextFields
              placeholder={t("receiverMobileNUmber")}
              onChange={(val) => onChange("mobileNumber", val)}
              size={isMobile ? "small" : "medium"}
            />
          </div>

          <CustomTextFields
            placeholder={t("receiverDescription")}
            onChange={(val) => onChange("note", val)}
            size={isMobile ? "small" : "medium"}
          />
        </div>
        <CustomButton
          onClick={() => {
            if (readyToBy.type === "BOGINSTALLMENT") {
              openModal();
            } else {
              onSubmitOrder();
            }
          }}
          text={t("confirm")}
          loading={loading}
          disabled={disabled}
        />
        {isLinkReady && (
          <CustomButton
            onClick={() => {
              const newTab = window.open("", "_blank"); // ← უსაფრთხოდ იხსნება ყველა ბრაუზერში

              try {
                newTab.location = isLinkReady;
              } catch (error) {
                newTab.close();
              } finally {
                setReadyToBy({
                  type: "",
                  open: false,
                });
                setLoading(false);
              }
            }}
            text={"ლინკის გახსნა"}
            loading={loading}
            disabled={disabled}
            buttonStyles={{
              marginTop: "10px",
            }}
          />
        )}
      </Root>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isUserAuthorized: state.main.isUserAuthorized,
});

const dispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, dispatchToProps)(MobileReadyToBuy);
